import React, { useState } from 'react';
import CardPrice from './CardPrice';
import CardPriceList from './CardPriceList';
import cardUtils from '../../utils/cardUtils';
import CardImage from './CardImage';
import AddToWishlistButton from '../wishlist/AddToWishlistButton';
import AddToCollectionButton from '../collection/AddToCollectionButton';
import Button from '../common/Button';

const CardItem = props => {
  const [allPrices, setAllPrices] = useState(false);
  const [allPricesButton, setAllPricesButton] = useState(
    'Mostrar más opciones',
  );
  const [allPricesButtonSign, setAllPricesButtonSign] =
    useState('fas fa-plus ml-2');

  return (
    <div className="w-full">
      <div className="flex flex-col bg-mediumColor shadow-md rounded-lg text-gray-700 p-4 gap-y-2">
        <div className="flex flex-col gap-y-2">
          <h4 className="text-xl text-center text-white">{props.card.name}</h4>
          <CardImage card={props.card} />
          <AddToWishlistButton card={props.card}></AddToWishlistButton>
          {/* The Deck Builder's card list swaps in a deck-quantity stepper here;
              everywhere else this is the collection stepper. */}
          {props.quantityControl || <AddToCollectionButton card={props.card} />}
        </div>

        {cardUtils.sortPrices(props.card.cardPrices)[0] && (
          <div className="flex flex-col gap-y-2">
            <h4 className="text-lg font-semibold text-center text-white">
              Mejor precio
            </h4>
            <CardPrice
              card={props.card}
              price={cardUtils.sortPrices(props.card.cardPrices)[0]}
              addToCart={true}
            />
            {cardUtils.sortPrices(props.card.cardPrices)[1] && (
              <Button
                className="w-full"
                iconClass={allPricesButtonSign}
                onClick={() => {
                  setAllPrices(!allPrices);
                  if (allPrices) {
                    setAllPricesButton('Mostrar más opciones');
                    setAllPricesButtonSign('fas fa-plus ml-2 align-middle');
                  } else {
                    setAllPricesButton('Mostrar menos opciones');
                    setAllPricesButtonSign('fas fa-minus ml-2 align-middle');
                  }
                }}>
                {allPricesButton}
              </Button>
            )}
          </div>
        )}

        {cardUtils.sortPrices(props.card.cardPrices)[1] && allPrices && (
          <CardPriceList
            card={props.card}
            prices={cardUtils.sortPrices(props.card.cardPrices).slice(1)}
          />
        )}
      </div>
    </div>
  );
};

export default CardItem;
